import { render, staticRenderFns } from "./BlockForEdit.vue?vue&type=template&id=17f02444&scoped=true&lang=pug&"
import script from "./BlockForEdit.vue?vue&type=script&lang=js&"
export * from "./BlockForEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f02444",
  null
  
)

export default component.exports